<template>
  <section class="bootcamp-coach">
    <div
      class="left-container"
      :style="{ background: `url(${coach.image}) center/cover no-repeat` }"
    ></div>
    <div class="right-container">
      <h3 class="section-subtitle">LEARN FROM THE BEST</h3>
      <h2 class="section-title">{{ coach.name }}</h2>
      <p class="section-description">
        {{ coach.description }}
      </p>
      <div class="buttons">
        <a class="btn" target="_blank" :href="twitch.url">
          <img src="@/assets/images/icons/company/twitch.svg" alt="twitch" />
          <span class="text">{{ twitch.copy }}</span>
        </a>
        <a
          class="btn"
          target="_blank"
          :href="youtube.url"
          v-if="Object.keys(youtube).length"
        >
          <img src="@/assets/images/icons/company/youtube.svg" alt="twitch" />
          <span class="text">{{ youtube.copy }}</span>
        </a>
      </div>
      <img
        loading="lazy"
        class="texture"
        src="@/assets/images/bootcamp/coach/texture.svg"
        alt=""
      />
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex"
export default {
  computed: {
    ...mapGetters("BootcampEnroll", ["bootcampCoachByKey"]),
    key () {
      return this.$route.params.key || this.$route.path.replace("/", "")
    },
    coach () {
      return this.bootcampCoachByKey(this.key)
    },
    twitch () {
      return this.coach.twitch || {}
    },
    youtube () {
      return this.coach.youtube || {}
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/_variables.scss";
@import "@/assets/style/_mixins.scss";
.bootcamp-coach {
  display: grid;
  grid-template-columns: 1fr 1fr;
  height: 96.1rem;
  width: 100%;
  margin: 0 auto;
  @include desktop-down {
    display: flex;
    flex-direction: column;
    height: unset;
  }
  .left-container {
    background: url("../../../../assets/images/bootcamp/coach/coach.jpg")
      center/cover no-repeat;
    height: 100%;
    width: 100%;
    @include desktop-down {
      height: 60rem;
    }
    @include phone-down {
      height: 23.8rem;
    }
  }
  .right-container {
    height: 100%;
    width: 100%;
    background: #131417;
    text-align: left;
    padding: 0 9.4rem;
    display: flex;
    justify-content: center;
    flex-direction: column;
    position: relative;
    @include desktop-down {
      text-align: center;
      align-items: center;
      padding-bottom: 3.5rem;
      padding-top: 2rem;
    }
    @include phone-down {
      padding: 2rem 1rem 3.5rem;
    }
    .section-subtitle {
      color: #f24462;
      font-weight: 600;
      font-size: 1.7rem;
      font-family: $font-primary;
      @include phone-down {
        font-size: 1.5rem;
      }
    }
    .section-title {
      color: #ffffff;
      font-weight: bold;
      font-size: 6rem;
      font-family: $font-primary;
      @include phone-down {
        font-size: 5rem;
      }
    }
    .section-description {
      font-weight: 500;
      font-size: 1.8rem;
      line-height: 151.8%;
      color: #ffffff;
      opacity: 0.5;
      max-width: unset;
      @include phone-down {
        font-size: 1.4rem;
        line-height: 130%;
      }
    }
    .buttons {
      display: flex;
      gap: 2rem;
      margin-top: 2.7rem;
      @include phone-down {
        flex-direction: column;
        gap: 1rem;
      }
    }
    .btn {
      height: 5rem;
      width: 24.5rem;
      display: flex;
      align-items: center;
      padding-left: 1.6rem;
      background: #fff;
      border-radius: 1.2rem;
      color: #0b0a1c;
      font-family: $font-poppins;
      font-weight: bold;
      font-size: 1.5rem;
      cursor: unset;
      position: relative;
      z-index: 2;
      cursor: pointer;
      @include desktop-down {
        width: 34.8rem;
      }
      @include phone-small {
        width: 95%;
      }
      .text {
        margin-left: 2rem;
      }
    }
    .texture {
      position: absolute;
      right: 0;
      bottom: 0;
      @include desktop-down {
        display: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bootcamp/enroll/coach/TheBootcampCoach.vue